module.exports = "/_next/static/images/ads-are-down-ae7612f560bb988a01a15e41aebee8fa.svg";